import React, { useState, useContext, useCallback, useEffect } from 'react'
import {
	useTranslation,
	//Trans,
} from 'react-i18next'

import download_interface_cream from 'img/document-icons/download-interface-cream.svg'

import {
	BoxInfoWithButton,
	CircleSpinner,
	getLanguageLocale,
	isSafariBrowser,
	//Tooltip,
} from 'shared/index'

import { Heading } from 'selfServicePortal/components/index'
import SspContext from 'selfServicePortal/contexts/SspContext'
import sddService from 'selfServicePortal/services/CreditCardServices/sddService'
import { SDDDisableModal } from './SDDDisableModal'
import { ISddMandate } from 'selfServicePortal/interfaces/i-api-sdd'

export const SDDOverview = () => {
	const { t } = useTranslation()
	const { customerData, isSddEligible } = useContext(SspContext)
	const [error, setError] = useState<boolean>(false)

	const [sddMandate, setSddMandate] = useState<ISddMandate | undefined>()
	//Need to know validToDate for below.. or atleast last withdrawal date. Update later on when BE is set up.
	const [renewMandate, setRenewMandate] = useState<boolean>(false) // eslint-disable-line @typescript-eslint/no-unused-vars
	const [showDisableModal, setShowDisableModal] = useState<boolean>(false)
	const [loading, setLoading] = useState<boolean>(false)

	const getSddMandate = async (partyId: string) => {
		try {
			await sddService
				.sddCustomerMandate(partyId)
				.then((response) => {
					if (response.status === 200) {
						let mandateData: ISddMandate = response.data
						setSddMandate(mandateData)
					}
				})
				.catch((error) => {
					console.warn(error)
					setError(true)
				})
				.finally(() => setLoading(false))
		} catch (error) {
			console.warn(error)
			setError(true)
			setLoading(false)
		}
	}

	const getSddMandateDocument = useCallback(
		async (mandateDocumentId: string, windowRef: Window | null) => {
			try {
				await sddService.getSddMandateDocument(
					mandateDocumentId,
					windowRef
				)
			} catch (error) {
				setError(true)
				console.warn(error)
			}
		},
		[]
	)

	useEffect(() => {
		setLoading(true)
		if (isSddEligible?.activeMandate)
			getSddMandate(customerData?.customerId!)
	}, [customerData, isSddEligible])

	return (
		<>
			{loading ? (
				<CircleSpinner />
			) : (
				<>
					{sddMandate !== undefined && (
						<div>
							<div className="heading">
								<h5 className="title">{t('SDD')}</h5>
							</div>
							<div className="sdd-overview">
								<div className="sdd-customer-overview">
									<div className="inner-box">
										<div className="sdd-info">
											<div>
												<div>{t('StartDate')}:</div>
												<div>
													<strong>
														{new Date(
															sddMandate.validFromDate
														).toLocaleDateString(
															getLanguageLocale()
														)}
													</strong>
												</div>
											</div>
											{/* Hiding renewal date until further notice */}
											{/* <div>
												<div>
													{t('RenewalDate')}:
													<Tooltip
														item={{
															value: (
																<Trans
																	t={t}
																	i18nKey="SDDMandateRenewalTooltip">
																	You can
																	renew your
																	mandate at
																	the
																	earliest, 4
																	weeks prior
																	to the
																	renewal
																	date.
																</Trans>
															),
														}}
													/>
												</div>
												<strong>N/A</strong>
											</div> */}
										</div>
										<br />
										<div className="sdd-info">
											<div>
												<div>{t('SDDMandateRef')}:</div>
												<div className="mandate-ref">
													{
														sddMandate.mandateDocumentId
													}
												</div>
											</div>
											<div>
												<div>{t('IBAN')}:</div>
												<div>
													{sddMandate.debtorIban}
												</div>
											</div>
										</div>
									</div>
								</div>
								{renewMandate ? (
									<div className="sdd-renew-mandate">
										<BoxInfoWithButton
											css={'info'}
											message={t('SDDRenewText')}
											button={
												<button
													type="button"
													className="btn btn-primary renew-mandate-btn">
													{t('SDDRenew')}
												</button>
											}
										/>
									</div>
								) : (
									<></>
								)}
								<div className="sdd-mandate-overview">
									<Heading
										title="SDDMandateTitle"
										description="SDDMandateDescription"
									/>
									<div className="download-mandate-section">
										<div>
											<button
												type="button"
												className="btn btn-primary download-mandate-btn"
												onClick={() => {
													let windowRef =
														isSafariBrowser()
															? window.open()
															: null
													getSddMandateDocument(
														sddMandate.mandateDocumentId,
														windowRef
													)
												}}>
												<span>
													{t('SDDDownloadMandate')}
												</span>
												<img
													src={
														download_interface_cream
													}
													className="download-icon-cream"
													alt="download icon"
												/>
											</button>
										</div>
										{error && (
											<div className="error-msg">
												{t('DownloadingFileError')}
											</div>
										)}
									</div>
									<div className="disable-mandate-section">
										<div>
											<p>{t('SDDMandateText')}</p>
										</div>
										<button
											type="button"
											className="btn btn-link-gray-11 disable-mandate-btn"
											onClick={() =>
												setShowDisableModal(true)
											}>
											{t('SDDDisable')}
										</button>
									</div>
								</div>
							</div>
							<SDDDisableModal
								show={showDisableModal}
								handleClose={() => setShowDisableModal(false)}
							/>
						</div>
					)}
				</>
			)}
		</>
	)
}
